export default __webpack_public_path__ + "static/bimbostore-86e6e1ff6fe98524b3bd37d147217b11.png";